module.exports = __webpack_public_path__ + "img/hr-V-R-2-load-connect-shadow.34a0d134.png";